import { render, staticRenderFns } from "./NationalSponsor.vue?vue&type=template&id=ed7c641a&scoped=true&"
import script from "./NationalSponsor.vue?vue&type=script&lang=js&"
export * from "./NationalSponsor.vue?vue&type=script&lang=js&"
import style0 from "./NationalSponsor.vue?vue&type=style&index=0&id=ed7c641a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7c641a",
  null
  
)

export default component.exports